import { connect } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
var mapStateToProps = function (state, props) { return ({}); };
var mapDispatchToProps = function (dispatch) { return ({
    pushAwardsModal: function (params) {
        dispatch(pushModal(ModalType.RECEIVED_AWARDS, { wrapInModal: false, params: params }));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CoreBadgeButton.container.js.map